import { render, staticRenderFns } from "./FiltersTaxonomySearch.vue?vue&type=template&id=13e84654&"
import script from "./FiltersTaxonomySearch.vue?vue&type=script&lang=js&"
export * from "./FiltersTaxonomySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports